import React, { useState, useEffect } from 'react';
import Sidebar from '../../components/Sidebar';
import Header from '../../components/header';
import Titulo from '../../components/Titulo/titulo';
import { useEducation } from '../../context/educationContext';
import Modal from '../../components/modal';
import { toast } from 'react-toastify';
import PlusCircle from '../../assets/icons/pluscircle.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faEye} from '@fortawesome/free-solid-svg-icons';
import useSubmitLock from '../../utils/useSubmitLock';

const Class = () => {
  const { listClasses, createClass, listCourses, listSchoolUnits } = useEducation();
  const [classes, setClasses] = useState([]);
  const [courses, setCourses] = useState([]);
  const [schoolUnits, setSchoolUnits] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedClass, setSelectedClass] = useState(null);
  const { isSubmitting, runWithSubmitLock } = useSubmitLock();

  const [formData, setFormData] = useState({
    date: '',
    class_code: '',
    name: '',
    actvite: true,
    course: '',
    school_unit: '',
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const classRes = await listClasses({ start_date: '2025-01-01' });
        setClasses(classRes.results || []);
        const courseRes = await listCourses();
        setCourses(courseRes.results || []);
        const schoolUnitRes = await listSchoolUnits();
        setSchoolUnits(schoolUnitRes.results || []);
      } catch (err) {
        console.error('Erro ao carregar dados:', err);
      }
    };
    fetchData();
  }, [listClasses, listCourses, listSchoolUnits]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    await runWithSubmitLock(async () => {
      try {
        await createClass(formData);
        setIsModalOpen(false);
        const updated = await listClasses({ start_date: '2025-01-01' });
        setClasses(updated.results || []);
        setFormData({
          date: '',
          class_code: '',
          name: '',
          actvite: true,
          course: '',
          school_unit: '',
        });
      } catch (err) {
        console.error('Erro ao cadastrar turma:', err);
        toast.error('Erro ao cadastrar turma');
      }
    });
  };

  return (
    <div>
      <Sidebar />
      <Header />
      <div className="container">
        <Titulo
          children={<h2>Turmas</h2>}
          children2={
            <button className="btnAdcionar" onClick={() => setIsModalOpen(true)}>
              <img src={PlusCircle} alt='icone' /> Cadastrar Turma
            </button>
          }
        />

        <div className="content content-table ">
          <table className="tabela">
            <thead>
              <tr>
                <th>Nome</th>
                <th>Código</th>
                <th>Data</th>
                <th>Ativa</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {classes.map((cls) => (
                <tr key={cls.id}>
                  <td>{cls.name}</td>
                  <td>{cls.class_code}</td>
                  <td>{new Date(cls.date).toLocaleDateString()}</td>
                  <td>{cls.actvite ? 'Sim' : 'Não'}</td>
                  <td>
                    <button onClick={() => setSelectedClass(cls)}>
                     <FontAwesomeIcon icon={faEye} className='icon' />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {isModalOpen && (
          <Modal
            isOpen={isModalOpen}
            closeModal={() => {
              setIsModalOpen(false);
              setFormData({
                date: '',
                class_code: '',
                name: '',
                actvite: true,
                course: '',
                school_unit: '',
                location: ''
              });
            }}
          >
            <h4>Cadastrar Turma</h4>
            <form onSubmit={handleSubmit}>
              <div className="form-group-large">
                <label>Nome</label>
                <input type="text" name="name" value={formData.name} onChange={handleInputChange} required />
              </div>
              <div className="form-group">
                <label>Código</label>
                <input type="text" name="class_code" value={formData.class_code} onChange={handleInputChange} required />
              </div>
              <div className="form-group">
                <label>Data</label>
                <input type="date" name="date" value={formData.date} onChange={handleInputChange} required />
              </div>
              <div className="form-group">
                <label>Curso</label>
                <select name="course" value={formData.course} onChange={handleInputChange} required>
                  <option value="">Selecione o curso</option>
                  {courses.map((course) => (
                    <option key={course.id} value={course.id}>{course.name}</option>
                  ))}
                </select>
              </div>

              <div className="form-group-large">
                <label>Unidade Escolar</label>
                <select name="school_unit" value={formData.school_unit} onChange={handleInputChange} required>
                  <option value="">Selecione a unidade escolar</option>
                  {schoolUnits.map((unit) => (
                    <option key={unit.id} value={unit.id}>{unit.name}</option>
                  ))}
                </select>
              </div>
              
              <div className='form-group'>
                <label>Ativo</label>
                <input type="checkbox" name="actvite" checked={formData.actvite} onChange={handleInputChange} />
              </div>
              <button type="submit" className="btnAcao" disabled={isSubmitting}>
                {isSubmitting ? 'Salvando...' : 'Salvar'}
              </button>
            </form>
          </Modal>
        )}

        {selectedClass && (
          <Modal
            isOpen={!!selectedClass}
            closeModal={() => setSelectedClass(null)}
          >
            <h4>Detalhes da Turma</h4>
            <form>
              <div className="form-group-large">
                <label>Nome</label>
                <input type="text" value={selectedClass.name} readOnly />
              </div>
              <div className="form-group">
                <label>Código da Turma</label>
                <input type="text" value={selectedClass.class_code} readOnly />
              </div>
              <div className="form-group">
                <label>Data</label>
                <input type="date" value={selectedClass.date ? selectedClass.date.split('T')[0] : ''} readOnly />
              </div>
              <div className="form-group">
                <label>Curso</label>
                <input type="text" value={selectedClass.course_name} readOnly />
              </div>
              <div className="form-group">
                <label>Módulo</label>
                <input type="text" value={selectedClass.modulo} readOnly />
              </div>
              <div className="form-group-large">
                <label>Unidade Escolar</label>
                <input type="text" value={selectedClass.school_name} readOnly />
              </div>
              <div className="form-group">
                <label>Turno</label>
                <input type="text" value={selectedClass.shift} readOnly />
              </div>
              <div className="form-group">
                <label>Dias</label>
                <input type="text" value={selectedClass.days} readOnly />
              </div>
              <div className="form-group">
                <label>Duração</label>
                <input type="text" value={selectedClass.duration} readOnly />
              </div>
              <div className="form-group">
                <label>É EAD?</label>
                <input type="text" value={selectedClass.ead ? 'Sim' : 'Não'} readOnly />
              </div>
              <div className="form-group">
                <label>Ativo</label>
                <input type="checkbox" checked={selectedClass.actvite} disabled />
              </div>
            </form>
          </Modal>
        )}
      </div>
    </div>
  );
};

export default Class;
